import $ from "jquery";
import _ from "underscore";

import Backbone from 'backbone';
import LogInView from './ip_login_view.js';

import { initializeFirebase } from './ip_login_view.js';
import { initializeApp } from 'firebase/app';
import {closeModal, showModal} from "js_helper_app/module.tail_helper.js";

Backbone.$(function () {
    window.logInView = new LogInView();

    window.logInView.showLoginPreLoader("Loading...");

    initializeApp({
        apiKey: window.firebase_api_key,
        authDomain: window.firebase_auth_domain,
    });

    window.logInView.initialize();

    if (window.sessionStorage.getItem('login-pending')) {
        window.sessionStorage.removeItem('login-pending');
        window.logInView.showLoginPreLoader();
    }

    if (_.isUndefined(window.orgId)) {
        window.logInView.orgId = window.orgId;
    }

    initializeFirebase();

    if (window.logInView.checkSignInViaEmail()){
    } else {
        closeModal($('#signin-loading-modal'));

        if (window.provider === 'password') {
            window.logInView.loginWithPassword();

            return;
        }

        if (window.sessionStorage.getItem('skip-auto-login')) {
            window.sessionStorage.removeItem('skip-auto-login');
        } else {
            window.sessionStorage.setItem('skip-auto-login', 1);

            if (window.provider === 'google.com') {
                window.logInView.googleLoginClicked();
            } else if (window.provider === 'apple.com') {
                window.logInView.appleLoginClicked();
            } else if (window.provider === 'microsoft.com') {
                window.logInView.microsoftLoginClicked();
            } else if (window.provider && window.provider !== "None") {
                window.logInView.ssoLoginClicked();
            }
        }
    }
});
